import React from 'react'
import styled from '@emotion/styled'
import { keyframes } from '@emotion/react'
import { CheckOutlined } from '@ant-design/icons'

interface StepIndicatorProps {
  step: number | string
  active: boolean
  finished?: boolean
}

export const StepIndicator = ({
  step,
  active,
  finished
}: StepIndicatorProps) => {
  return (
    <StepIndicatorCircle
      className={`${active ? '-active' : ''} ${finished ? '-finished' : ''}`}
    >
      {finished ? <CheckOutlined /> : step}
    </StepIndicatorCircle>
  )
}

const radiate = keyframes`
  from {
    border-radius: 50%;
    border: 2px solid #e7e5e9;
    color: #a4a4b3;
  }

  to {
    border: 2px solid #4a4a68;
    outline: 4px solid #E2E4FB;
    color: #4a4a68;
  }
`

const StepIndicatorCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;

  border-radius: 50%;
  border: 2px solid #e7e5e9;
  background-color: #f3f2f4;
  color: #a4a4b3;

  font-weight: 600;

  &.-active {
    animation: ${radiate} 150ms ease-in-out forwards;
    background-color: white;
  }

  &.-finished {
    background-color: #4a4a68;
  }

  &.-finished span svg {
    fill: white;
  }
`
